(function(){
  function ready(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function(){
    document.querySelectorAll('.fb-code').forEach(function(btn){
      btn.addEventListener('click', function(){
        var code = btn.dataset.code || btn.textContent.trim().split(' ')[0];
        var label = btn.querySelector('span');
        var done = function(){
          btn.classList.add('copied');
          if (label) label.textContent = 'Copied';
          setTimeout(function(){
            btn.classList.remove('copied');
            if (label) label.textContent = 'Copy';
          }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch(e){}
          document.body.removeChild(ta);
          done();
        }
      });
    });

    if (window.location.search.indexOf('customer_posted=true') > -1){
      var ok = document.querySelector('.fb-signup-ok');
      if (ok){
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(function(){
          ok.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'center'});
        }, 500);
      }
    }
  });
})();
